import * as React from 'react';
export const IcFolderRated = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M19 6h-6.59l-1.12-1.12A3 3 0 009.17 4H5a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V9a3 3 0 00-3-3zm-3.62 6.49l-1.07 1 .25 1.51a.85.85 0 01-1.24.9L12 15.21l-1.32.69a.85.85 0 01-1.24-.9l.25-1.47-1.07-1A.86.86 0 019.1 11l1.47-.22.66-1.33a.86.86 0 011.54 0l.66 1.33 1.47.22a.86.86 0 01.48 1.49z'
      fill='currentColor'
    />
  </svg>
);
